import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { MaintenanceService } from '../../../core/services/maintenance.service';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-maintenance-mode',
  standalone: true,
  imports: [],
  templateUrl: './maintenance-mode.component.html',
  styleUrls: ['./maintenance-mode.component.scss']
})
export class MaintenanceModeComponent implements OnInit, OnDestroy {
  maintenanceSchedule: any = null; // Holds the fetched maintenance schedule
  private isBrowser: boolean;
  remainingTime: { days: number; hours: number; minutes: number; seconds: number } = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  };
  private timerSubscription!: Subscription; // Subscription for the interval timer
  private pollingSubscription!: Subscription;
  constructor(private maintenanceService: MaintenanceService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if( this.isBrowser){
      this.fetchMaintenanceSchedule();
      this.startStatusPolling();
    }
  }

  ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  fetchMaintenanceSchedule(): void {
    this.maintenanceService.getMaintenanceSchedule().subscribe((res: any) => {
      this.maintenanceSchedule = res.data;

      if (this.maintenanceSchedule.isActive) {
        const endTime = new Date(this.maintenanceSchedule.toDateTime);
        const now = new Date();

        if (endTime.getTime() < now.getTime()) {
          // If maintenance end time has already passed, redirect immediately
          this.router.navigate(['/home']);
          return;
        }
        if(this.isBrowser){
          this.startCountdown(endTime);
        }
      }else{
        this.router.navigate(['/home']);
      }
    });
  }

  startCountdown(endTime: Date): void {
    // Unsubscribe from the previous timer if it exists
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  
    this.timerSubscription = interval(1000).subscribe(() => {
      const now = new Date().getTime();
      const timeRemaining = endTime.getTime() - now;
      console.log("timeRemaining",timeRemaining);

         // Calculate days, hours, minutes, and seconds
         this.remainingTime.days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
         this.remainingTime.hours = Math.floor(
           (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
         );
         this.remainingTime.minutes = Math.ceil((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
         this.remainingTime.seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      if (timeRemaining <= 0) {
        this.timerSubscription.unsubscribe(); // Stop the timer
        this.remainingTime = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        this.router.navigate(['/home']);
        return;
      }
  
   
    });
  }

  startStatusPolling(): void {
    this.pollingSubscription = interval(10000).subscribe(() => { // Poll every 10 seconds
      this.fetchMaintenanceSchedule();
    });
  }


  
  
}
